<template>
  <div class="mc-delivery-track-sidebar-accordion-item">
    <div header-tag="header" role="tab">
      <div
        class="d-flex justify-content-between"
        @click="$root.$emit('bv::toggle::collapse', 'accordion-' + doorLevel)"
      >
        <h5>
          {{
            'Aktivitas Sensor Pintu ' + (totalData > 1 ? doorOption : '') + ' di Lokasi Pengiriman'
          }}
        </h5>
        <div>
          <i class="mc-fa icon-fill_arrow-ios-down"></i>
          <i class="mc-fa icon-fill_arrow-ios-up"></i>
        </div>
      </div>
    </div>

    <!-- Accordion utama -->
    <b-collapse :id="'accordion-' + doorLevel" accordion="outer-accordion" role="tabpanel">
      <div v-if="!hasDataDoor" class="text-center">
        <img width="100" class="mb-4" alt="uploading" :src="emptyState" />
        <p>
          <strong>{{ 'Belum ada data' }}</strong>
        </p>
        <p class="text-muted">
          {{
            'Pengemudi dalam perjalanan ke Lokasi Ambil. Pantau terus untuk melihat perbaruannya.'
          }}
        </p>
      </div>

      <div v-else>
        <b-card
          v-if="data.pickup.length > 0"
          class="mc-delivery-track-sidebar-accordion-item-card mb-3"
        >
          <div header-tag="header" role="tab">
            <div v-b-toggle.accordion-item-1 class="d-flex justify-content-between">
              <h5>{{ 'Lokasi Ambil' }}</h5>
              <div>
                <i class="mc-fa icon-fill_arrow-ios-down"></i>
                <i class="mc-fa icon-fill_arrow-ios-up"></i>
              </div>
            </div>
          </div>

          <b-collapse id="accordion-item-1" accordion="inner-accordion" role="tabpanel">
            <div class="mc-delivery-track-sidebar-sensor-activity">
              <div
                v-for="(group, groupIndex) in groupedPickup"
                :key="groupIndex"
                class="mc-delivery-track-sidebar-sensor-activity-item clearfix"
              >
                <div class="mc-delivery-track-sidebar-sensor-activity-item-line">
                  <i class="mc-fa icon-outline_arrow-circle-right"></i>
                </div>
                <div class="mc-delivery-track-sidebar-sensor-activity-item-detail">
                  <b-skeleton-wrapper :loading="isLoading">
                    <template #loading>
                      <b-skeleton width="90%" />
                    </template>
                    <p style="grid-area: history-date">
                      {{ formatIndexDate(group.date).date }}
                    </p>
                    <b-row v-for="(item, itemIndex) in group.items" :key="itemIndex" class="mb-2">
                      <b-col md="4">
                        <span class="text-muted">{{ formatIndexDate(item.sent_on).time }}</span>
                      </b-col>
                      <b-col md="8">
                        <div class="d-flex align-items-center gap-1">
                          <i
                            :class="[
                              'mc-fa',
                              item.status === 0
                                ? 'icon-outline_door-close'
                                : 'icon-outline_door-open',
                            ]"
                          ></i>
                          <span>
                            <strong>
                              {{ item.status === 0 ? 'Pintu Tertutup' : 'Pintu Terbuka' }}
                            </strong>
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-skeleton-wrapper>
                </div>
              </div>
              <div class="mc-delivery-track-sidebar-sensor-activity-item clearfix">
                <div class="mc-delivery-track-sidebar-sensor-activity-item-line">
                  <i class="mc-fa icon-fill_radio-button-on"></i>
                </div>
              </div>
            </div>
          </b-collapse>
        </b-card>

        <b-card
          v-if="data.drop.length > 0"
          class="mc-delivery-track-sidebar-accordion-item-card mb-3"
        >
          <div header-tag="header" role="tab">
            <div v-b-toggle.accordion-item-2 class="d-flex justify-content-between">
              <h5>{{ 'Lokasi Kirim' }}</h5>
              <div>
                <i class="mc-fa icon-fill_arrow-ios-down"></i>
                <i class="mc-fa icon-fill_arrow-ios-up"></i>
              </div>
            </div>
          </div>

          <b-collapse id="accordion-item-2" accordion="inner-accordion" role="tabpanel">
            <div class="mc-delivery-track-sidebar-sensor-activity">
              <div
                v-for="(group, groupIndex) in groupedDrop"
                :key="groupIndex"
                class="mc-delivery-track-sidebar-sensor-activity-item clearfix"
              >
                <div class="mc-delivery-track-sidebar-sensor-activity-item-line">
                  <i class="mc-fa icon-outline_arrow-circle-right"></i>
                </div>
                <div class="mc-delivery-track-sidebar-sensor-activity-item-detail">
                  <b-skeleton-wrapper :loading="isLoading">
                    <template #loading>
                      <b-skeleton width="90%" />
                    </template>
                    <p style="grid-area: history-date">
                      {{ formatIndexDate(group.date).date }}
                    </p>
                    <b-row v-for="(item, itemIndex) in group.items" :key="itemIndex" class="mb-2">
                      <b-col md="4">
                        <span class="text-muted">{{ formatIndexDate(item.sent_on).time }}</span>
                      </b-col>
                      <b-col md="8">
                        <div class="d-flex align-items-center gap-1">
                          <i
                            :class="[
                              'mc-fa',
                              item.status === 0
                                ? 'icon-outline_door-close'
                                : 'icon-outline_door-open',
                            ]"
                          ></i>
                          <span>
                            <strong>
                              {{ item.status === 0 ? 'Pintu Tertutup' : 'Pintu Terbuka' }}
                            </strong>
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-skeleton-wrapper>
                </div>
              </div>
              <div class="mc-delivery-track-sidebar-sensor-activity-item clearfix">
                <div class="mc-delivery-track-sidebar-sensor-activity-item-line">
                  <i class="mc-fa icon-fill_radio-button-on"></i>
                </div>
              </div>
            </div>
          </b-collapse>
        </b-card>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { formatIndexDate } from '@/helpers/tzDate'
import emptyState from '@/assets/images/nodata.png'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        pickup: [],
        drop: [],
      }),
    },
    doorLevel: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    totalData: {
      type: Number,
      default: 0,
    },
    doorOption: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return { emptyState }
  },
  computed: {
    isLoading() {
      return this.loading
    },
    groupedPickup() {
      if (!this.data?.pickup?.length) return []

      const groups = {}

      const formatDate = (isoString) => {
        const date = new Date(isoString)
        return date.toLocaleDateString('id-ID', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })
      }

      this.data.pickup.forEach((item) => {
        const dateKey = formatDate(item.sent_on)
        if (!groups[dateKey]) groups[dateKey] = []
        groups[dateKey].push(item)
      })

      return Object.keys(groups).map((dateKey) => {
        const items = groups[dateKey]
        const firstSentOn = items[0].sent_on
        return {
          date: firstSentOn,
          items,
        }
      })
    },
    groupedDrop() {
      if (!this.data?.drop?.length) return []

      const groups = {}

      const formatDate = (isoString) => {
        const date = new Date(isoString)
        return date.toLocaleDateString('id-ID', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })
      }

      this.data.drop.forEach((item) => {
        const dateKey = formatDate(item.sent_on)
        if (!groups[dateKey]) groups[dateKey] = []
        groups[dateKey].push(item)
      })

      return Object.keys(groups).map((dateKey) => {
        const items = groups[dateKey]
        const firstSentOn = items[0].sent_on
        return {
          date: firstSentOn,
          items,
        }
      })
    },
    hasDataDoor() {
      return this.data?.pickup?.length > 0 || this.data?.drop?.length > 0
    },
  },
  methods: {
    formatIndexDate,
  },
}
</script>
